import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "search-option-container" }
const _hoisted_3 = { class: "search-bar-container" }
const _hoisted_4 = {
  class: "label",
  for: "equipement-filter"
}
const _hoisted_5 = { class: "search-bar-container" }
const _hoisted_6 = {
  class: "label",
  for: "groupe-filter"
}
const _hoisted_7 = { class: "search-bar-container" }
const _hoisted_8 = {
  class: "label",
  for: "ssgroupe-filter"
}
const _hoisted_9 = {
  key: 1,
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "btnWrapper" }
const _hoisted_11 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_TickBox = _resolveComponent("TickBox")!
  const _component_ButtonWhite = _resolveComponent("ButtonWhite")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_EquipementList = _resolveComponent("EquipementList")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'height-95pct': _ctx.openInfoEquipement }, "step-three-container"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('equipementSelection.search.title')), 1),
      _createVNode(_component_ReglePastille, { cle: "demandeIntervention.rechercheEquipementCriteres" }),
      _createVNode(_component_ReglePastille, { cle: "demandeIntervention.etatEquipementObligatoire" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          id: "equipement-filter",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.equipementFilter) = $event)),
          class: "search-input",
          placeholder: " ",
          required: "",
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.equipementFilter]
        ]),
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('equipementSelection.search.equipement.placeholder')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          id: "groupe-filter",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.groupeFilter) = $event)),
          class: "search-input",
          placeholder: " ",
          required: "",
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.groupeFilter]
        ]),
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('equipementSelection.search.groupe.placeholder')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          id: "ssgroupe-filter",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ssGroupeFilter) = $event)),
          class: "search-input",
          placeholder: " ",
          required: "",
          type: "text"
        }, null, 512), [
          [_vModelText, _ctx.ssGroupeFilter]
        ]),
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('equipementSelection.search.ssgroupe.placeholder')), 1)
      ]),
      (_ctx.displayRadio)
        ? (_openBlock(), _createBlock(_component_TickBox, {
            key: 0,
            "aria-checked": _ctx.equipement === null,
            "aria-label": _ctx.$t('equipementSelection.search.none'),
            selected: _ctx.equipement === null,
            class: "tick",
            role: "checkbox",
            tabindex: "0",
            onClick: _ctx.equipementMissing,
            onKeydown: [
              _withKeys(_ctx.equipementMissing, ["enter"]),
              _withKeys(_withModifiers(_ctx.equipementMissing, ["prevent"]), ["space"])
            ]
          }, null, 8, ["aria-checked", "aria-label", "selected", "onClick", "onKeydown"]))
        : _createCommentVNode("", true),
      (_ctx.displayRadio)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('equipementSelection.search.none')), 1))
        : _createCommentVNode("", true),
      (_ctx.displayRadio)
        ? (_openBlock(), _createBlock(_component_ReglePastille, {
            key: 2,
            cle: "demandeIntervention.equipementNonTrouve"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "extra-actions", {}, undefined, true),
          _createVNode(_component_ButtonWhite, {
            onClick: _ctx.clearFilter,
            text: _ctx.$t('button.clear'),
            class: "clearBtn"
          }, null, 8, ["onClick", "text"]),
          _createVNode(_component_ButtonBlue, {
            disabled: _ctx.disabled(),
            onClick: _ctx.search,
            text: _ctx.$t('button.search'),
            class: "searchBtn"
          }, null, 8, ["disabled", "onClick", "text"])
        ])
      ])
    ]),
    _createElementVNode("div", {
      ref: "equipementDiv",
      class: "equipement-list",
      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
    }, [
      _createVNode(_component_EquipementList, {
        "display-radio": _ctx.displayRadio,
        equipements: _ctx.equipementList,
        multiple: _ctx.multiple,
        "open-info-equipement": _ctx.openInfoEquipement,
        "selected-ids": _ctx.selectedIds,
        "excluded-equipement-ids": _ctx.excludedEquipementIds,
        "allow-select-all": _ctx.allowSelectAll,
        "equipement-namespace": _ctx.equipementNamespace,
        onSort: _ctx.doSort,
        "onUpdate:selectedIds": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:selectedIds', $event)))
      }, null, 8, ["display-radio", "equipements", "multiple", "open-info-equipement", "selected-ids", "excluded-equipement-ids", "allow-select-all", "equipement-namespace", "onSort"])
    ], 544)
  ], 2))
}